export enum PackageType {
  SVA = 3,
  Endpoints = 4, // BEST
  Sandbox = 5, // Sandbox Security Appliance
  Ghostr = 6, // Ghostr Network Sensor
  Frat = 7,
  RelayForFrat = 8,
  NSVA = 9, // Network Security Virtual Appliance
  K8s = 10, // Kubernetes
}
